export const applicationConfig = {
  SUPPORT_URL: "https://support.iclub.vc/hc/en-us/requests/new",
};
